export default "__VITE_ASSET__BOw$lPOh__"